module.exports = [
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Transparantie over hoe je werkt naar alle collega’s, leerlingen etc. is belangrijk."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Ik denk dat je je bewust moet zijn dat je weet dat wanneer je op een normale manier feedback uit dit anders opgevat kan worden. Dus, dat je je bewust moet zijn van je nieuwe rol, constant moet kunnen anticiperen en je bewust moet zijn van je omgeving."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Je moet kunnen schakelen zonder dat dit onrust veroorzaakt en je moet flexibel zijn."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Als je iemand bent die veel creatiever en vrijer in het leven staat, kan ik me voorstellen dat dat veel beter werkt. "
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Je moet kunnen relativeren. Het accepteren dat de dingen niet gaan zoals je je hebt voorgenomen. Dat vind ik echt een heel belangrijke eigenschap."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Als dingen door elkaar gaan ritsen, loopt het niet lekker. Ik moet daarom voor mezelf de dagen goed afbakenen. Daar probeer ik nier meer aan te tornen. Dus, als niemand dat in gevaar brengt en ik doe het zelf niet, dan is die afbakening duidelijk en daar heb ik enorm veel baat bij."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Je leert de combinatie voor jezelf te organiseren en je hoopt een beetje op de medewerking aan beide kanten. Als je daarin investeert, dan lukt dat. "
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Het is meer nodig om grenzen te bewaken. Als je nog een andere baan hebt, is het dus niet vanzelfsprekend dat er even wat uren worden bij gepland. Dan zit je meteen tot over je oren in het werk. Je moet daarom duidelijk maken wat je constructie is."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Wanneer je meer uitdaging nodig hebt, is er blijkbaar iets dat je niet genoeg voldoening geeft binnen het huidige onderwijswerk. De school weet dat je naar buiten kijkt, dan kan daar maar beter aandacht aan besteed worden."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Ook afspraken kunnen maken over vergaderdagen en in je docententeam afspraken kunnen maken over urenplanning vormen een succesfactor."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Het rooster is voor mij heel bepalend, omdat dat zorgt dat je kunt doen waar je goed in bent en dat bij twee werkgevers. "
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Het is wel een beetje afhankelijk van de bereidheid van de school om mee te werken aan de bijzonderheid van je combi-situatie. Ik moet daar elk jaar weer even over soebatten. Want, het is dus geen recht dat me gegund is, maar een gunst als het gaat om het meedenken met mijn rooster. "
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Waardering is belangrijk."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Ik heb een leidinggevende die meedenkt met mijn constructie. De schoolleiding ziet de kracht ervan."
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Ruimte voor een combinatie hangt een beetje af van het vak, volgens mij. Zo wordt het vak Nederlands aan de meeste klassen vier of drie uur per week gegeven. Als je dan één dag zou werken, dan heb je een klas vier uur achter elkaar. Dat is uitgesloten. "
	},
	{
		"rol": "A",
		"categorie": "Tips & tricks",
		"quote": "Ik denk dat 0,4 fte in beide banen wel een ondergrens is. Kleiner kan niet, maar meer hoeft niet per se. Natuurlijk kun je met meer aanwezigheid wel meer doen en ook meer met collega’s praten voor het schoolgevoel."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Wees open over wat je doet."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je gaat in je privéleven meer selecteren. Dit doe ik wel en dit doe ik niet. Maar als ik er dan aandacht aan besteed, dan doe ik dat ook volledig. Dan is werk ook echt uit en is het niet half-half."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet praktisch en realistisch ingesteld zijn."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je wordt voor jezelf geen betere werkgever en ook geen betere werknemer als je ook geen leuk persoon bent dus je moet daar wel een balans in vinden. Anders kun je je werk niet meer goed doen."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Ik houd mezelf best wel strak aan mijn schema."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Een goede baas zegt wel eens: 'en nou is het klaar!'. Je moet voor jezelf ook een goede baas zijn. Je hebt aan dat project zoveel uur besteed en nu is het ook goed en klaar."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet tegenover jezelf je grenzen kunnen aangeven en eerlijk kunnen zeggen wanneer iets echt te veel is of wanneer je er iets bij kunt hebben."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Ik moet de tijd oormerken voor mezelf, want anders komt het er niet van. Dan blijf je gewoon met je schoolwerkzaamheden bezig, omdat je denkt: 'dat is toch mijn vaste werkgever dus daar moet je dan het meeste aandacht aan besteden.' Maar, je moet ook voor je eigen werkzaamheden klaarstaan."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet goed op jezelf kunnen passen en goed op jezelf terug kunnen kijken. Een stukje zelfreflectie kunnen geven wat betreft wat je wilt en kunt."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Ik wel het gevoel dat ik steeds mezelf ben, maar dat ik me wel steeds aanpas aan de context. Het is niet dat ik me heel anders ga gedragen, maar ik ben me er wel van bewust dat ik de ene keer meer in mijn docentrol ben, dan in mijn projectmanager-rol of trainerrol. "
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Ik doe al heel snel meer dan wat aan taken nodig is. Ik heb daarbij wel mijn grenzen aangegeven.  Ik vind het ook grote onzin om te focussen op hoeveel uur je precies dient te maken. Wel is het goed om je grenzen te bewaken en te kijken naar wat je er nog naast je lessen bij doet."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Heldere communicatie en verwachtingsmanagement zijn een vereiste. Je werkt voor verschillende partijen en het is fijn als je tegen je leidinggevende kunt zeggen: 'ik ben nu voor mijn andere werk bezig dus ik heb nu geen tijd' of: 'we hebben nu dit afgerond, is het goed als ik hier later op terugkom? Ik moet me nu even daarop focussen'. "
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Naar collega’s toe wil ik vooral niet preken, maar ik wil wel af een toe een vraag stellen die ze verder helpt. Ik merk dat ik ook binnen school af en toe een heel klein beetje dat docenten-trainerschap overneem, maar heel gematigd want anders is het ook gewoon niet leuk. Dan krijg je inderdaad van: 'o, meneer weet alles beter'."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet een verantwoordelijkheidsgevoel hebben ten opzichte van je taken. Dat als je besluit dat je iets voor school gaat doen, dat je dit ook doet wanneer de rest even druk is en vice versa. Ook wanneer dit betekent dat alles tegelijk bij elkaar komt."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet goed kunnen onderhandelen als het gaat om roosterwensen bijvoorbeeld."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Eigenlijk denk ik dat je ook in je privéleven meer moet gaan plannen. Door bijvoorbeeld te zeggen: 'vandaag doe ik gewoon eens een dag niets'."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet breed geïnteresseerd zijn. Als je dit niet bent, hebben twee banen die heel verschillend zijn ook geen nut."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet de meerwaarde van allebei, van de combinatie zien, zodat in ieder geval de ene baan de ander wat kan geven. Dat betekent in mijn geval dat ik in mijn onderzoek praat over mijn onderwijs en in het onderwijs praat over mijn onderzoek."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet jezelf goed kunnen monitoren. Je moet in ieder geval een beetje in de gaten kunnen houden wanneer je moet stoppen en aan kunnen geven wanneer iets niet kan."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Communiceren is heel belangrijk. Je moet zorgen dat je weet hoe je aangeeft wat je kan opleveren en waar je grenzen liggen."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je hebt twee groepen collega’s, twee culturen waarmee je te maken hebt.  Die twee matchen, dat kost moeite en als gevolg moet je daar constant mee bezig zijn: 'waar ben ik nu en wat wordt er van me verwacht?'."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "De belangen van beide partijen zijn heel verschillend; niet altijd, soms hebben ze natuurlijk raakvlakken. Maar, het doel is dat je die twee weet de rijmen en dat is wel écht een uitdaging."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je moet heel veel praktische zaken regelen. Ik heb bijvoorbeeld te maken met twee cao’s. Je hebt twee verschillende arbeidsvoorwaardenregelingen en dat betekent dat je constant moet matchen met wat de ene partij wil en wat de andere partij wil. Daar moet je een weg in vinden."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Een tip om goed te kunnen combineren: ik combineer mijn inhoud met mijn lessen. Als ik een economieleraar zou zijn, dan zou het heel veel schelen als mijn tweede baan ook iets met een bedrijf of met iets economisch te maken heeft. Dan kan je het namelijk combineren. Dat maakt het veel makkelijker en dan haal je ook de maatschappij de les in en vice versa. "
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Het mooiste blijft het eigenlijk als je overal hetzelfde doet. Als de directeur van een bedrijf of een zzp’er in de klas zou komen. Dan moet je maatschappijleer gaan geven en niet Frans. Dat maakt het zoveel makkelijker en ook leuk. Je kunt het over je vak hebben. Dat heeft meteen zeggenschap. Je kan meteen alles gebruiken en dat maakt het heel levendig. "
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Alles wat ik doe, zit in een bepaalde hoek. Dus een bepaalde vaardigheid waarvan ik althans denk te weten dat ik dat kan. Omdat ze elkaar 'kruisbestuiven', kun je ze combineren. Je gebruikt van het ene werk het andere werk. Je kan er gebruik van maken dat de banen in dezelfde richting zijn. "
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Kies het veld waar je je expertise in wilt laten groeien. Kruisbestuiving helpt. Je kan er gebruik van maken als banen in dezelfde richting zijn. "
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Je bent in de tijd van je vaste werkgever niet flexibel en in je eigen tijd bij je eigen projecten wel. Dat is soms wel een nadeel."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Voor mij kostte het niet veel tijd om grip te krijgen op de situatie, maar ik had het makkelijk. Ik begon met lesgeven en werd er daarna zzp’er bij. Zzp’en, dat bouw je op in het begin. Je doet het nog niet zolang en je moet nog klanten zien te vinden. Dat groeit gewoon met je mee en het is geen vaste baan dus dat is heel anders werken."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Het is belangrijk om heldere afspraken te maken met je werkgever over wat je buiten de lestaken nog doet. Dan heb ik het over die zogenaamde taakuren, maar ook over bijvoorbeeld op welke ouderavonden je wel of niet aanwezig bent. "
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Sommige collega’s zeggen: 'super vet, wat doe je allemaal en wat kan je ermee?' en andere collega’s hebben zoiets van: 'o, daar heb je dat ‘wereldse type’ weer.' Misschien niet per se met die woorden maar wel zo van: 'o, jij komt dus buiten de school en jij bent dus anders'."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Er moet vertrouwen zijn in het feit dat je in het belang van school handelt, ook als je iets mist. Dat is wel een basisvoorwaarde. Als je te maken hebt met een school die wil dat jij overal bij bent, dan werkt dat niet."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Collega’s die ervoor open staan, zijn belangrijk. Het gaat er vooral om dat je een school hebt waarbij het geaccepteerd wordt en dat het niet in de weg staat voor een goede band met je collega’s."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Heel veel overleg en openheid is van belang."
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Vertrouwen is de sleutel van succes. Dat zei ik al voordat ik dit ging doen. Als je hier op je meest fragiel binnenkomt, moe van het andere werk, dat ze dan weten dat het oké is dat je niet bij de ene vergadering aanwezig was. "
	},
	{
		"rol": "B",
		"categorie": "Tips & tricks",
		"quote": "Ik denk dat iedereen die minder dan drie dagen op school is, de feeling met de school verliest."
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Je moet cognitief flexibel zijn en het is belangrijk om snel te kunnen schakelen. "
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Je moet goed overzicht kunnen houden over alle werkzaamheden en kunnen plannen. Pragmatisch zijn. "
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Als ambtenaar moet je het aankunnen dat er bagger over je wordt uitgestort over leraren. Je moet het je niet aantrekken, een wat dikkere huid hebben. Kunnen relativeren is belangrijk. "
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Je moet op de goede momenten integer zijn. Mijn school had bijvoorbeeld een subsidie-aanvraag aangevraagd die helemaal niet kon. Toen ik net bij het Ministerie van OCW werkte, voerde de school druk op mij uit of ik dit niet even kon regelen. Dat kan niet. Het moet duidelijk zijn wat je wel en niet kunt doen. "
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Het helpt als je in een team terecht komt waar informatie wordt gedeeld."
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Inhoudelijk is er bij je werk als ambtenaar bij drie dagen meer mogelijk."
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "De gewenste aanwezigheid als rijksambtenaar hangt af van type beleidsmedewerker. Als je dossierhouder wilt zijn is twee dagen te weinig. In het algemeen is twee dagen de ondergrens."
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Als je als docent-ambtenaar dossiers deelt of samen doet, dan is er minder aanwezigheid vereist. Wanneer je geen dossierhouder bent, ben je flexibeler. Het gaat om het verschil tussen 'mede-verantwoordelijke' of 'eindverantwoordelijke'."
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Als ambtenaar op vo-beleid wordt je ingezet als dossierhouder en is drie dagen dus een vereiste."
	},
	{
		"rol": "C",
		"categorie": "Tips & tricks",
		"quote": "Ideaal zou het zijn bij beide werkgevers drie dagen aanwezig te zijn, maar dat gaat niet."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Het uitganspunt is dat het enige wat vast staat in mijn agenda, de lestijden op school zijn. Dan moet ik er gewoon zijn. Voor de rest heb ik voor mijn andere bezigheden veel afspraken in het land en die plan ik zo efficiënt mogelijk in. Voor de rest heb ik veel kleine dingen. Daar heb ik altijd een zo gestructureerd mogelijke lijst van."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Op school heb ik wat vaste afspraken over toetsen die binnen zoveel dagen doorlooptijd nagekeken moeten zijn, dus daar zitten altijd een soort deadlines aan. Binnen mijn bureau probeer ik natuurlijk wel enigszins gestructureerd declaraties de deur uit te sturen, maar daar zit niet een overdreven vaste routine in."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Probeer zo strikt mogelijk en zo eenduidig mogelijk aan timemanagement te doen. Als je dat niet doet, loopt alles uit de hand, ga je deadlines passeren en wordt het een chaos."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Je moet met alles een afweging maken en je grenzen bekijken qua tijd. Dat er bij het combineren tijd overblijft voor jezelf, voor je familie en voor je vriendin."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Grenzen stellen, maar voor iedereen is het anders wat hij kan en accepteert. Bij beide banen moet je zelf je grenzen stellen en is het belangrijk dat je deze tegen anderen durft te zeggen: 'Ik doe dat een keer niet, want ik heb geen tijd meer'."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Je moet goed zelf kunnen inschatten waar je nodig bent en waar niet."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Een ondernemer zal waarschijnlijk makkelijker kunnen combineren dan iemand anders omdat hij/zij verschillende balletjes heeft hoog te houden. Daar kunnen vaak nog wel twee of drie balletjes bij als leraar in het voortgezet onderwijs. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Ik merk van mezelf dat ik op heel veel terreinen heel veel verschillende dingen doe en kan. Dat ik die ook allemaal naast elkaar onderhoudt en dat is soms wel vermoeiend maar, aan de ander kant ben ik wel zo’n persoon. Daarmee bedoel ik: 'zo’n ondernemer, die als die maar één ding zou doen, snel verveeld zou raken'. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Durf wel gewoon over je bedrijf en je onderneming te vertellen. Zelf heb ik me daar binnen de school altijd een beetje voor geschaamd. Waarom weet ik ook niet, maar gewoon vanwege dat commerciële. Tja, het is ambtenarij hè, het onderwijs. Zonder mijn collega’s te kort te doen, er zit niet meteen veel innovatie en creativiteit in het onderwijs, dus ik heb eigenlijk altijd mijn mond erover willen houden. Maar ik merk eigenlijk wel dat mensen er geïnteresseerd in zijn en het hartstikke leuk vinden. Dus nu praat ik er wel over. Neem zelf initiatief om er dingen over te zeggen."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Om begrip te creëren moet je zo open mogelijk over spreken met collega’s op school over wat je ernaast doet."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Je moet tegen een stootje kunnen. Ik kom wel eens terug op de dinsdag en dan is alles anders dan toen ik de week ervoor op woensdag wegging en bepaalde dingen heb afgesproken. Van die veranderingen ben je dan in de tussentijd niet op de hoogte gesteld. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Een student die houdt er geen rekening mee dat ik er alleen maar op dinsdag en woensdag ben, dus ik krijg continu e-mails. Ik beantwoord die allemaal, of ik nu aan het werk ben voor mijn eigen bedrijf en of dit nu op woensdag of een zaterdag is. Ik ben dus ook buiten die twee dagen dat ik op school ben, bereid om me daarvoor in te zetten."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Ik vind het totaal niet vervelend dat mijn werkzaamheden door elkaar heenlopen en dat ik daartussen moet switchen. Ik vind het ook niet vervelend als ik voor mijn eigen werkzaamheden op een zaterdag of een zondag 'moet' werken. Ik doe mijn werk graag en of dat nu zaterdag, zondag of in vakanties is, dat maakt me niet uit."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Dat ik hier op school ben, kost me ongeveer €200. Maar, dat heb ik er graag voor over. Het is voor mij niet belangrijk maar als je er goed naar kijkt, dan is het wel aan de orde dat je er financieel op inlevert."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Er wordt weinig rekening mee gehouden dat mensen niet op alle dagen van de week kunnen.  Er wordt eigenlijk vanuit gegaan dat als mensen parttime werken, ze de rest van de dagen dan wel vrij zullen zijn."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Ik heb gewoon de lerarenopleiding gedaan en ik zie daar ook echt wel het nut van in. Ik zou het ook heel oneerlijk vinden als iemand anders zonder bevoegdheid leraar maatschappijleer zou worden. Dus, ik zou wel kijken of er in ieder geval een flexibel traject aan te bieden is, zodat iemand binnen school ook een didactische bevoegdheid kan halen. Dat is ook wel belangrijk, wil je goed onderwijs kunnen geven. Dat je iets goed kan overbrengen en dat je klassenmanagement op orde is."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Ik denk dat docenten écht een aanvulling kunnen zijn binnen het bedrijf. Het zijn vaak wel mensen met een gevarieerde toolset van eigenschappen die een aanvulling kunnen zijn voor een bedrijf. In die zin zijn het heel interessante werknemers. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Zeker een aantal jaren in een andere branche werken, zie ik als een aanvulling op je docentschap. Mogelijk op detacheringsbasis. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Als het puur gaat om tijd en indeling, is dit het grootste euvel waar ik binnen mijn organisatie tegenaan loop. Deze is niet altijd vrij of vormt in ieder geval een punt van discussie. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Ik denk dat iemand die naast onderwijs ook nog ergens anders werkzaam is, de school heel veel extra’s kan geven, maar dat er wel gebruik van gemaakt moet worden en dat die persoon wel gezien moet worden. Ik denk dat dat nu heel weinig gebeurt. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Ik was geneigd om op school mezelf te kort te doen door veel ’s avonds en in het weekend te werken, met stress als gevolg. Dat heeft er ook voor gezorgd dat ik nu andere keuzes heb gemaakt."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Je moet qua planning naar de school toe best wel stevig in zijn; dat ze je bedrijf serieus nemen. Als je ergens anders in dienst bent, dan passen ze zich wel aan, maar op het moment dat je eigen baas bent, is de verwachting dat jij je wel meer aan kan passen."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Het begint met interesse en weten wat je ernaast doet. Dat lijkt vanzelfsprekend maar dat valt wel mee. Ik denk dat mijn leidinggevenden eigenlijk niet weten wat ik precies doe en zij hebben nooit gevraagd: 'hé, maar wat doe je nou eigenlijk in die andere twee dagen?'. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Ik denk echt dat docenten die iets naast het lesgeven doen een aanvulling kunnen zijn binnen de school en als dat gezien wordt, is dat echt wel een aanwinst."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Privé moet je goed op jezelf letten en je moet wel tegen een stootje kunnen af en toe. Het is hard werken."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Het maken van een rooster is lastiger. Ik wil me daarin niet flexibeler opstellen; dat kan ik niet. Ik moet  gewoon een x-aantal dagen vrij zijn voor mijn andere werkzaamheden."
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Als de meerwaarde gezien wordt, zorgt dit voor een stukje plezier: 'ik word erkend door mijn school en door mijn collega's'. "
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Een ondernemer heeft andere vaardigheden dan een docent. Ga eens kijken wat je daarmee kan doen. Kijk eens goed wat voor types je binnenhaalt in plaats van: 'Ik heb een docent Frans nodig'. Wat heeft die persoon nog meer?"
	},
	{
		"rol": "D",
		"categorie": "Tips & tricks",
		"quote": "Mijn collega’s weten allemaal wat ik doe en ze zijn daar heel begripvol voor. Ze zetten mij daar ook mee in mijn kracht. Mijn kracht is mijn eigen bedrijf en de kennis die ik heb van mijn vak. Daar zetten ze mij ook voor in. "
	},
	{
		"rol": "A",
		"categorie": "Motieven",
		"quote": "Doordat ik ook een baan heb als regulier docent, ben ik aantrekkelijker voor mijn werkgever bij de lerarenopleiding. "
	},
	{
		"rol": "A",
		"categorie": "Motieven",
		"quote": "Het combineren biedt een uitbreiding van je netwerk."
	},
	{
		"rol": "A",
		"categorie": "Motieven",
		"quote": "Fulltime docenten zijn erg gericht op docentschap, wat aan de ene kant goed is, maar aan de andere kant ook beperkend kan werken, omdat ze niets zien van de buitenwereld. Dus, ik zou graag zien dat heel veel docenten in het regulier onderwijs ook iets anders erbij doen. Dat kan van alles zijn. Dan sta je ook gewoon in de wereld, niet alleen in de onderwijswereld."
	},
	{
		"rol": "A",
		"categorie": "Motieven",
		"quote": "Interessant is dat je met een parttime baan wel beter wordt om 'nee' te zeggen tegen allerlei extra organisatorische zaken. Je hebt immers ook een andere baan. Dat is geen parttime penalty, maar een parttime privilege."
	},
	{
		"rol": "A",
		"categorie": "Motieven",
		"quote": "Ook wanneer je in hetzelfde vak doceert, kan dit nog verrijkt worden wanneer je dat voor totaal andere leerlingen doet."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik werk aan iets in een project met een kop en een staart, leidend tot bijvoorbeeld een nieuwe methodiek of product. Dat is een welkome afwisseling ten opzichte van het onderwijs dat door de drukte vaak in zichzelf gekeerd is op een eigen eiland. Meer contact met anderen is belangrijk voor me."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik ben aantrekkelijker voor werkgevers in het regulier onderwijs. Ze vragen naar aanleiding van mijn eigen onderneming meteen naar wat ik doe en vinden dat dan super leuk. Het maakt het gemakkelijker voor mij een goede indruk te geven en tevens communiceer ik mijn ondernemerschap."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Je hebt te maken met verschillende doelgroepen. Niet alleen met leerlingen maar ook met volwassenen en docenten die iets van je willen leren."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik vind het combineren van banen interessanter dan het hebben van één baan. Je houdt jezelf veel scherper dan als je in een soort routine vervalt. En je houdt het op deze wijze uitdagend. Bij het docentschap merkte ik dat als ik dit fulltime zou doen, dat ik het moeilijk zou vinden om te weten wat er buiten die onderwijssetting nog meer speelt."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Wanneer je in een andere omgeving komt, word je soms even wakker geschud en bedenk je je: 'o ja, we kunnen het ook op een andere manier doen'."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Na een eerste proefperiode vond ik het voor mezelf heel waardevol om door te zetten, omdat je merkt dat die verschillende banen elkaar kruisbestuiven en dat je dan ook veel meer om je heen ziet dan als je 40 uur op dezelfde werkplek zit."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik ervaar het hebben van meerdere banen als verrijking en ik voel me veel vrijer. Het klinkt misschien raar, maar ik ervaar meer flexibiliteit ten opzichte van de situatie waarin ik één baan had. Je ervaart dat je zelf werk naar je toe kunt trekken en dus ook echt werk doet wat je op dat moment interessant vindt."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Het draagt voor mij bij aan een plezierige werksituatie en aan een gezonde situatie, omdat ik me als docent niet beperkt wil voelen tot een lesgevende rol. Ook voel ik me flexibeler, omdat ik meer kan kiezen in welke levensfase welke werksituatie bij me past."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Het houdt het spectrum breed voor wat je nog meer op de arbeidsmarkt zou kunnen doen. Dat is ook een heel belangrijke factor voor mij."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Je ziet dat mensen heel positief op je reageren. Ook andere werkgevers: 'goh, je doet dit én dat!'"
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "De plus bestaat uit de vaardigheden die je onderhoudt, het breed houden van het perspectief en daarmee ben je ook voor andere werkgevers aantrekkelijk."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Je haalt allerlei kleine dingen binnen die je prikkelen om goed na te denken over het werk dat je doet en voor mij betekent dit ook een stukje waardering. Dit komt doordat mensen het interessant vinden wat je te vertellen hebt en daardoor wil je je dan ook steeds meer verdiepen en beter worden in je werk."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Het feit dat je andere ideeën en visies krijgt omdat je buiten die muren van je eigen school treedt, dat is één van de redenen is waarom ik gekozen heb voor deze combinatie."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik denk dat het belangrijk is om jonge docenten aan te trekken. Zij gaan nu niet het onderwijs in omdat zij zeggen: 'ja, maar dan kun je alleen maar dat doen, dan ben je ‘gewóón’ leraar'. Terwijl je toch ook ‘gewóón’ bankier bent? Maar ja, dat is wel de beeldvorming in Nederland. Misschien dat als mensen weten dat je het docentschap voor jezelf veel rijker kunt maken, dat het dan aantrekkelijker zou zijn."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Het is fijn om in verschillende omgevingen te werken en het is fijn dat je niet gebonden bent aan één plek."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Je wordt als werknemer aantrekkelijker voor je vaste werkgever als je daarnaast ook ondernemer met aanvullende skills bent. Het geeft je meer mogelijkheden binnen je vaste werk omdat men denkt: 'o, jij kan dat, nou, dan heb ik dit en dit lopen en misschien wil je eens proberen om dat op te pakken'."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Als je voor jezelf financiële zekerheid creëert, creëer je ook de durf om dingen te proberen buiten je vaste werk. Dit kan vervolgens succesvoller uitpakken omdat je niet die enorme druk voelt om alleen aan de financiële noodzaak te moeten voldoen. Je kan dan echt het werk doen omdat je dat leuk vindt. Niet omdat je erbij móet werken."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Het is fijn om te merken dat je zelf proactief bent en echt iets voor elkaar kunt krijgen, dat je echt onafhankelijk bent van anderen en dat je uit je eigen groep kunt stappen. De wetenschap dat dit kan, houdt het wat ontspannener."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Als je bij één werkgever werkt, ben je iets minder eigenaar van wat je doet. De zelfstandigheid die je voelt als je banen combineert, is groter."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik heb het gevoel dat ik de regie meer in eigen handen heb en dat maakt mij gelukkiger. Het geeft mij het gevoel dat als ik echt doorzet, ik mijn vaste baan nog kleiner kan maken en nog meer voor mijn eigen projecten kan gaan in de toekomst."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Mensen van buiten het onderwijs hebben soms een beperkt beeld van wat een docent kan. Het is jammer dat dat idee heerst, want docenten kunnen heel veel verschillende dingen, maar dat komt dan toch niet erg uit de verf op je cv."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Na een jaar fulltime als docent te hebben gewerkt, vond ik dat het me te weinig nieuwe dingen bracht. Ik was al een tijd bezig met gamification en daarin geef ik nu training als zzp'er."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Door de combinatie kun je meer interessante mensen ontmoeten."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Je bent redelijk autonoom als docent en wat dat betreft denk ik dat het goed is om ook iets te doen buiten het onderwijs, zodat je ook zicht houdt op wat zich daar afspeelt. Dat kan dan bij een bedrijf zijn of als hybride ambtenaar, maar in ieder geval zo dat je een breder perspectief hebt."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Wat je met plezier doet, levert ook energie op. Juist de afwisseling zorgt voor meer plezier dus per saldo wekt het dan ook meer energie op."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik denk dat veel docenten niet zien wat er mogelijk is om ernaast te doen. Ik denk dat de meeste docenten misschien dan nog denken aan 'auteur' of 'iets bij een uitgever'. Maar, er zijn in mijn beleving niet zoveel mensen die denken: 'o, ik ga twee dagen bij Capgemini werken en drie dagen voor de klas staan'."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Door in het onderwijsveld te zijn, zit ik niet te verstoffen achter mijn computer in mijn kantoortje. Dat zorgt ervoor dat ik blijf functioneren en niet depressief word, denk ik. Ik denk dus dat ik er gelukkiger van word."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik wil niet alleen maar onderzoek doen maar ook iets in de praktijk doen."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik denk dat het heel belangrijk is dat als ik verder wil in onderzoek, ik ook in de praktijk ben geweest. Dat is voor veel mensen niet zo, maar ik vind dat wel echt een meerwaarde. Dat geldt voor mij persoonlijk, maar ik merk ook dat steeds meer mensen dat als een algemeen belang zien."
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik heb twee masters gehaald; ééntje voor Engels en ééntje voor onderwijs, dan mag je eerstegraads leraar worden. Maar, dat doe je dan veertig jaar en dan? Daarom denk ik bij combinatiebanen; hoe meer, hoe beter in het onderwijs. Dan haal je juist die actualiteit naar binnen. "
	},
	{
		"rol": "B",
		"categorie": "Motieven",
		"quote": "Ik ben zóveel gegroeid sinds 5 jaar geleden. Ik heb door mijn promotieplaats zóveel meer ingangen dan dat ik eerst had. Ja, dan blijf je toch echt bij dezelfde kennis en dan moet je het ergens anders vandaan halen. Nou, dit is een manier om bij te scholen. "
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Als leraar-ambtenaar kun je het onderwijs eens met een helikopterview bekijken."
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Je kunt het onderwijs vanuit alle perspectieven en facetten bekijken."
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Je ziet de andere kant van het onderwijs. "
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Als leraar ben je vaak idealist, heb je een bepaalde visie op onderwijs en zie je bepaalde dingen vastlopen. Als ambtenaar kan je dat ook op een groter niveau kwijt."
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Ik kan nu ook in een grotere en meer professionele organisatie werken. Dat biedt ook meer ontwikkelmogelijkheden. "
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Als ambtenaar kan je makkelijker en meer stappen maken omdat je werkt in een getrapte organisatie."
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Ik kan mijn bestuurlijke interesses en interesse in beleid in de andere baan kwijt. "
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Het is zeer nuttig voor professionals om te leren een ander (beleids)perspectief aan te nemen. "
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Verbanden leggen tussen praktijk en beleid, dat vind ik leuk. De win-win? Leren van elkaar!"
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Als docent kan ik ideeën vanuit de praktijk kwijt in mijn ambtenarenbaan en ervoor zorgen dat docenten gehoord worden."
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Je kunt echt iets veranderen; het verschil maken."
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Om ambtenaren naar het onderwijs te trekken, zou je als slogan kunnen hanteren: 'vijf dagen in die toren is te veel'."
	},
	{
		"rol": "C",
		"categorie": "Motieven",
		"quote": "Bekeken vanuit een beleidsfunctie bij ministerie van OCW is het werken in het onderwijs 'behind enemy lines'. Andersom ook."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Het is erg leuk om min of meer elk uur echt iets heel anders te doen en om in verschillende omgevingen met compleet verschillende mensen te mogen werken."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Ik ben veel vrolijker sinds ik op die school rondloop, omdat ik het gewoon heel gezellig vind hier."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Hiervoor heb ik bij het accountantsbureau gewerkt en ook lesgegeven aan de universiteit in Tilburg. Voorheen had ik dus ook al een combinatiebaan. Ik ben weer les gaan geven omdat ik het gewoon heel leuk en inspirerend vind. Ook met het leeftijdsniveau wilde ik wat doen voor het creëren van begrip jegens eigen kinderen."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Ik wil het niet te zwaar aanstippen, maar je doet als docent een heel klein beetje iets aan burgerschapsvorming. We zijn geen Moeder of Vader Theresa en we moeten vooral niet onze eigen rol overschatten, maar het is wel heel leuk dat je met een kleinigheidje iets kunt betekenen, dat is ook wel heel waardevol."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Deze combinatie zie ik als iets als wat me energie geeft vanuit de variatie die het biedt."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Mede de maatschappelijke bijdrage, maakt dat ik het werken in het onderwijs leuk en belangrijk vind."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Dat ik nog steeds combineer, is omdat ik mijn vak een belangrijk vak vind en omdat ik het leuk vind om middelbare scholieren kennis te laten maken met 'ontwerpend denken'. Dit is iets wat ik zelf ook graag als vak op de middelbare school gehad zou willen hebben en wat ik mee wil geven aan deze generatie."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Bouwkunde was een vrij eenzijdige opleiding en als architect dacht ik nog wel wat extra bagage te kunnen gebruiken."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "De diversiteit in dingen maakt het prettig. Je maakt echt veel mee in een week tijd, je ontmoet veel mensen en hebt veel collega’s. Dat is leuk en gezellig. Het houdt het ook voor jezelf interessant dat je met heel veel thema’s bezig bent. Dus er is genoeg om mee bezig te zijn en om over na te denken. "
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Uiteindelijk maakt het geheel dat het past. Als docent is het salaris prima, maar ook niet zoals in het bedrijfsleven. Aan de andere kant betekent een eigen bedrijf onzekerheid, dus de combinatie maakt dat je deze tegenover elkaar kunt wegstrepen. Je kunt dus aan de ene kant zeggen: de vastigheid van het lesgeven is een voordeel en van de andere kant kan het financieel interessant zijn om meer uren in het bedrijfsleven te steken."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Je leert een hoop in het onderwijs. Tegelijkertijd, omdat ik ook nog andere dingen kan, neem ook wel weer een stukje creativiteit mee naar het onderwijs. De vaardigheden die ik in het onderwijs opdoe, gebruik ik in mijn andere werk en de vaardigheden die ik daar opdoe, kan ik ook weer in het onderwijs toepassen."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Ik heb een open blik. Als ik alleen in het onderwijs zou werken, zou ik al heel snel en makkelijk alle dingen opnoemen die niet goed gaan in het onderwijs. Als ik mijn ondernemers-pet op zet, kan ik vanuit de organisatie redeneren, kan ik relativeren en snap ik ook dat dingen zo werken. "
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Mijn combinatie met ondernemerschap vergemakkelijkt mijn contact met de leidinggevenden, omdat ik niet altijd als een stier op een rode lap te werk ga. Dat ik denk dat er een gedachte achter zit, dat ik snap dat er keuzes gemaakt moeten worden. Ik merk dat ik daarin ook wel genuanceerder ben. Ik ben in ieder geval genuanceerder gaan denken dan de meeste collega’s."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Ik heb al tien jaar in de marketing-communicatie gezeten naast het onderwijs. En die marketing heeft het nooit gewonnen van het onderwijs. Blijkbaar vind ik onderwijs gewoon té leuk."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Ik heb nu een onderwijsbaan die ik drie dagen per week leuk vind om te doen en daarnaast kan ik met mijn eigen freelance-activiteiten nog een heel mooi zakcentje verdienen om mijn leven nog leuker te maken."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Door de combinatie blijft het onderwijs leuk. In die zin, ik vind het onderwijs eigenlijk het leukste wat ik doe, maar op het moment dat ik dit fulltime zou doen, dan denk ik dat ik om een heleboel redenen sneller klaar zou zijn met het onderwijs. "
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "De reden waarom ik het doe, is omdat ik een vakman ben. Ik wil die passie die ik heb voor mijn vak Vormgeven aan mijn studenten overbrengen en die mogelijkheid heb je als 'man in het vak'. Je kunt je studenten echt veel meer laten zien en ze geloven je ook meer. Dat is echt een enorm voordeel, vind ik."
	},
	{
		"rol": "D",
		"categorie": "Motieven",
		"quote": "Ik houd van de dynamiek van het bedrijfsleven, maar ook in het onderwijs zie je de passie. En daarbij komt nog dat studenten voor directe feedback zorgen. Ik leer zelf ook elke dag."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Vanuit de lerarenopleiding geef ik aan studenten heel veel feedback. Dat is iets dat naar mijn mening in het reguliere onderwijs richting leerlingen en tussen docenten onderling te weinig gebeurt. Ook hoop ik mee te geven dat docenten nooit uitgeleerd kunnen zijn."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Ik kan stagiaires van de lerarenopleiding beter begeleiden op school, omdat ik weet wat de opleiding vraagt. Of ik kan andere docenten veel beter instrueren hoe je een stagiair moet begeleiden."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Ik kan stagiaires veel makkelijker aan de school verbinden. Ik heb zicht op deze populatie en kan ze bereiken en contact brengen met school."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Banen erbij, is blikken erbij. Je brengt maatschappelijk issues die je in de onderwijspraktijk tegenkomt mee de colleges in."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Ik neem kennis uit een echte klas, hoe het eraan toegaat, mee naar de lerarenopleiding. Daar zijn toch veelal docenten die niet meer voor de klas staan. Ik kan daarmee de toekomstige docenten echt iets meegeven."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Je staat als deeltijd lerarenopleider eigenlijk qua kennis en vaardigheden een beetje boven het reguliere onderwijs. Je kunt met een helicopterview kijken wat je in je sectie qua leerlijnen aan het doen bent en aangeven: 'lees dit eens of lees eens dat, ik heb nu de ervaring met dit, dit moeten we anders gaan doen'."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Vanuit de schoolleiding en binnen mijn eigen sectie is er waardering voor het feit dat ik ook vakdidactische vakken geef naast de taalkundige vakken. Omdat je er best veel over leert, nog veel meer dan je er al over wist van je eigen lerarenopleiding. Bijvoorbeeld nieuwe werkvormen, daar zit je echt bovenop. "
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "De directe toepassing van theorie en praktijk is een meerwaarde voor zowel het regulier onderwijs als voor mijn werk als leraar-opleider. Tijdens colleges voor aankomende docenten merk je dat je serieus genomen wordt. Je kunt direct voorbeelden aanhalen uit je eigen praktijk als docent."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Je had tot voor kort ook docenten die bij de lerarenopleiding werken, maar die in geen twintig jaar een middelbare school van binnen hadden gezien. Het is goed als mensen het weten waar ze het over hebben. En ja, dat wordt gewaardeerd."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Er is een veel grotere en blijvende kruisbestuiving. De hogeschool waardeert enorm dat je zelf met de poten in de klei staat, dus zelf weet waar je het over hebt. Dat wat je de studenten vertelt, doet uit eigen ervaring. Dat kan een ervaring zijn die kort geleden is, maar het is nog veel fijner als het iets blijvends is."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "In mijn colleges en bijvoorbeeld tijdens stagebegeleiding, ken ik het klappen van de zweep. Ik weet hoe het eraan toegaat op een gemiddelde middelbare school. Dat is makkelijk als je als leraar-opleider zelf ook op een middelbare school werkt."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Ik heb geprobeerd de praktische manier van lesgeven, met experimentjes en dergelijke, bij mijn andere school ook toe te passen in de biologielessen voor leerlingen in het volwassenonderwijs die in 21 weken hun biologielessen doorlopen."
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Wat ik ook uit de vavo leer, is hoofd- en bijzaken sterk uit elkaar te houden. Bij de vavo zijn er 24 weken en dan moet er eindexamen worden gedaan. Dat triggert je om to the point te komen en om strakke keuzes te maken in je lesstof. Dat doe ik nu op het gymnasium ook meer en dat laat daar ruimte en tijd over voor echte discussies met leerlingen. "
	},
	{
		"rol": "A",
		"categorie": "Opbrengsten",
		"quote": "Aan de vavo doceer ik allerlei jongeren die ouder zijn dan 18 jaar en die om de een of andere reden hun school niet hebben afgemaakt. Je kunt zeggen dat de maatschappij in haar volle breedte in de klas zit. Ik kom bij de vavo in aanraking met ook echt andersdenkenden over bijvoorbeeld IS en de rol van Amerika. Ik wil me ontwikkelen als docent die niet oordeelt, maar wel hamert op argumentatie. Dat leer ik op vavo en neem ik mee naar het gymnasium."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "De combinatie met ondernemerschap levert me in het lesgeven de mogelijkheid op om zaken die ik in mijn onderneming oppik, te testen in de klas. Ik kan ideeën voor onderwijsvernieuwing meteen toepassen."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Ik ben bezig geweest met een partij die speelfilms in de klas willen gebruiken als lesmateriaal. Ik heb daar de didactische elementen aan toegevoegd zoals de leerdoelen het moet bedienen. Dit breng ik concreet mee naar school om aan vernieuwing en innovatie te doen."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Ik ben een interessante partij voor andere ondernemers om mee samen te werken op het gebied van onderwijs. Ik heb meteen toegang tot de klas en kan didactisch iets toevoegen."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Ik denk dat leerlingen in de toekomst niet met zo’n traditionele vorm van werk te maken krijgen. Moet je als docent dan ook niet weten dat je niet altijd met een zekere, vaste baan te maken hebt maar ook zelf dingen naar je toe moet kunnen trekken? Het is handig als je daar als docent iets over kunt vertellen en hoe je dat dan doet."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Juist voor docenten is het belangrijk om ervaring te hebben in het vakgebied. Leerlingen hebben dit zelf ook door en zeggen: 'wat weet u daar nou van, u zit toch alleen maar op school?'. Aan de ene kant is dit kortzichtig, maar soms hebben ze ook wel gelijk. Dan geef je bijvoorbeeld al 40 jaar economie op die school, maar heb je nog nooit meegedraaid in een bedrijf."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Je kunt nu vanuit een ander perspectief ook meepraten en je kennis van buiten naar binnen toehalen. En ik denk dat dat ook belangrijk is om aan de leerlingen te laten zien."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Buiten school kan ik dingen uitproberen. Dan merk je dat bepaalde dingen eigenlijk heel goed werken en die durf je dan ook bij je vaste werkgever te doen. Zo gebruik je meer onconventioneel lesmateriaal. Je hebt dus de ruimte om te experimenteren in dit terug te brengen in je vaste werk."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Ik zet ervaringen uit ho, vo en mijn trainingen bij elkaar in. Dat betekent verschillende contexten en beelden combineren. Ik merk dat dat héél erg krachtig is."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Als ik met mensen van de universiteit praat over de financiën, dan kan ik zeggen welke impact dit heeft op leerlingen én op docenten. Ik verbaas me hoe effectief dat is op dit moment. "
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Door mijn andere baan als onderwijsinnovator kan ik de leerlingen een cooler verhaal bieden."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "In de klas kan ik mijn praktijkervaring kwijt en is er tegelijk ruimte voor mijn creativiteit."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Mensen weten dat ik naast het lesgeven ook nog zzp’er ben. Vanuit de directie wordt dit heel erg gewaardeerd. Heel praktisch, ze vragen me concrete zaken of in overleg weten ze dat ik vanuit mijn rol als docent-trainer zicht heb op bepaalde dingen. Dat is fijn."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "De school profiteert nu van mijn expertise en het feit dat er innovatie is binnen de school en zij hoeven daar niet zelf voor te betalen doordat er subsidie voor is. Dat is dus voor een groot deel tot stand gekomen doordat ik ook als zelfstandige werk."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Ik kan wat ik graag doe niet in één baan doen. Het doen van een onderzoek samen met mijn eigen collega's is nieuw. We gaan evalueren wat de universiteit en de onderwijspraktijk hier aan hebben om duidelijk te krijgen wat de meerwaarde van zo’n combibaan is."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Uit morele overtuiging vind ik dat er meer mensen moeten zijn die onderzoek doen in het onderwijs en vice versa. En, voor mij persoonlijk geldt dat ik mij wil ontwikkelen op onderzoeksgebied, maar heel veel energie krijg van lesgeven. Als je die twee zaken dan kunt combineren dan is dat mijn ideale baan."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Ik vind de koppeling tussen wetenschap en praktijk belangrijk."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Ik gaf een les aan een 6-vwo-klas en dacht: 'Ik ga eens in op een vraag in mijn proefschrift'. Hoe gebruik je een holocausttoneelstuk in het onderwijs? Die hele discussie die volgde met de leerlingen, die kan letterlijk mijn proefschrift in."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Iemand die naast het lesgeven nog wat anders doet, kan in de klas misschien beter omgaan met maatschappelijke moeilijke zaken, omdat hij of zij ook met zijn of haar benen in de buitenwereld staat."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Het moet geen verplichting worden, maar ik vind hybride werken zo’n verrijking voor scholen en universiteiten. Onderwijs is goed te combineren en ik denk soms: 'onderwijs zou eigenlijk alleen maar combinatie moeten zijn, in ieder geval veel meer'. Dat ieder vakgebied ook met een poot in de maatschappij staat. Dat is precies wat we nodig hebben voor scholen en voor de toekomst."
	},
	{
		"rol": "B",
		"categorie": "Opbrengsten",
		"quote": "Wat ik als onderzoeker probeer te doen is de kennis uit mijn proefschrift mee te nemen naar de klas. Dat vind ik echt maatschappelijk waardevol."
	},
	{
		"rol": "C",
		"categorie": "Opbrengsten",
		"quote": "Als ambtenaar kan ik diverser ingezet worden wanneer je gevraagd wordt voor je expertise als docent."
	},
	{
		"rol": "C",
		"categorie": "Opbrengsten",
		"quote": "Ik heb vanwege mijn werk met veel verschillende samenwerkingsverbanden te maken en weet hoe beleid op de werkvloer uitwerkt. Ambtenaren kijken daar vaak anders naar."
	},
	{
		"rol": "C",
		"categorie": "Opbrengsten",
		"quote": "De functie van leraar-ambtenaar zorgt ervoor dat 'de praktijk' direct bij ons aan tafel zit als we beleid ontwikkelen."
	},
	{
		"rol": "C",
		"categorie": "Opbrengsten",
		"quote": "Wij zijn nieuwsgierig en kijken met een frisse en onbevangen blik naar het beleidswerk."
	},
	{
		"rol": "C",
		"categorie": "Opbrengsten",
		"quote": "Als leraar wordt er meer over dan met ons gepraat en anderen bepalen vaak wat we moeten doen. We zochten naar een mogelijkheid om daar verandering in te brengen en ontdekten dat we als leraar-ambtenaar praktijk en beleid met elkaar kunnen verbinden."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Het combineren is gewoon mentaal heel leuk. Het maakt me ook productiever, want in mijn geval zie ik dat ik er niet aan ontkom om uitermate efficiënt te zijn."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Wat echt een voordeel is, is dat ik heel veel dingen uit mijn praktijk kan inbrengen in mijn les. Dan heb ik ergens een adviesopdracht of een controle gedaan en kan ik daar allerlei punten uit meenemen als praktijkvoorbeeld in mijn les."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Ik heb altijd wel een leuke anekdote uit een klassensetting als ik ergens kom en het ijs een beetje moet breken. Of, ik kan met een opdrachtgever die een kind heeft in een eindexamenklas net iets meer een relatie opbouwen."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Je weet wat er gevraagd wordt vanuit het bedrijfsleven en je weet wat er verandert. Je kent de vaardigheden die van mensen gevraagd worden, die veranderen ook, en je weet welke kennis daarbij komt kijken. Dat kun je aan leerlingen meegeven. Daarnaast blijft ook je bedrijf echt up-to-date vanuit het lesgeven."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Het combineren, houd je goed scherp op alle vlakken. Je hebt echt in de gaten waar je zelf mee bezig bent. Als je puur vanuit een bedrijf les gaat geven dan moet je ook goed nadenken over: 'hoe pak ik dingen zelf aan?', 'wat weet ik eigenlijk?' en 'hoe breng ik dingen over?'. Door les te geven, reflecteer je op je eigen handelen in de praktijk."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Het verhaal van een docent wordt eigenlijk alleen maar beter wanneer die vanuit de praktijk praat. Als een docent Frans twee dagen in de week ergens werkt waar die veel bezig is met de Franse taal, dan is dat een verrijking voor beiden."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Ik kom uit de marketing. De technieken die ik daar leer om de aandacht te houden, gebruik ik ook in mijn lessen. Ik zorg dat de dingen die ik vertel, aansprekend blijven."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Ik leer heel veel van de groepen waarvoor ik sta en dat kan ik toepassen in mijn werk als ondernemer. Daar moet je ad rem zijn en de aandacht erbij kunnen houden. Je merkt dat je al gauw op een andere manier heel zakelijk maar toch heel concreet en duidelijk kan overbrengen wat ik kom doen."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Ik word in mijn eigen bedrijf geconfronteerd met persoonlijke zaken. Drugsgebruik bij één van onze stagiaires bijvoorbeeld. Dan merk ik dat ik veel beter weet te handelen dan mijn compagnons, omdat zoiets binnen school wel vaker voorkomt en daar allerlei handelingen voor klaarliggen. "
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Een docent moet met veel verschillende kinderen omgaan en op veel verschillende manieren met iemand het gesprek aan kunnen gaan. Dat leer je in het onderwijs en dat kun je vervolgens ook weer in je bedrijf toepassen."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Wanneer je als ondernemer in het onderwijs werkt, levert je dit een groot netwerk op. In mijn geval werken er veel mensen op school. In die hoedanigheid heb ik wel wat extra opdrachten gekregen. Bijvoorbeeld doordat de man van een collega of de vrouw van een collega iemand nodig had op dat gebied."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Ik zie vaak dat docenten wel cursussen volgen op pedagogisch of didactisch gebied maar vakinhoudelijk volgen zij vaak geen cursussen. Maar dingen veranderen in ons vakgebied zo snel dat wat men tien jaar geleden hebben geleerd eigenlijk niet meer geldt vandaag de dag."
	},
	{
		"rol": "D",
		"categorie": "Opbrengsten",
		"quote": "Het geeft een kick om les te geven. We hebben unieke praktijkkennis in huis, we weten precies hoe we de opleiding kunnen laten aansluiten op de praktijk en hoe we de lesstof tastbaar kunnen maken."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/quotes.json
// module id = 17
// module chunks = 0